<section class="main-wrap inner-views">
  <div class="container-wrap">
    <div class="sidebar-container sc-empty">
      <app-sidebar-empty></app-sidebar-empty>
    </div>
    <div class="content-container login-container address-container">
      <div class="row">
        <div class="col-md-12">
          <h1>Welcome to Eyelation</h1>
          <p class="subtitle">Add Photo</p>
          <p><em>A photo is REQUIRED for eyewear purchase to<br> accurately measure the user’s eye
          distance.</em></p>
        </div>
        <div class="add-photo-wrap">
          <div class="row add-photo">
            <div class="col-md-6">
              <app-secure-image [filename]="previewImageName"
                [hasThumbnail]="false"
                [style]="'user-photo'">
              </app-secure-image>
            </div>
            <div class="col-md-6">
              <h2>Uploaded Photo</h2>
              <p>Eyelation-profile-picture.jpeg</p>
              <p class="margin-top-40">Upload File</p>
              <div class="input-group mb-3">
                <div class="custom-file">
                  <input aria-describedby="inputGroupFileAddon01" class="custom-file-input" id="inputGroupFile01"
                    type="file" (change)="onFileChange($event)">
                  <label class="custom-file-label" for="inputGroupFile01">{{filename}}</label>
                </div>
              </div>
              <div class="upload-btn">
                <input (click)="uploadPhoto()" id="uploadBtn" type="button" value="Upload">
              </div>
              @if (isSubmitted && !isValidFile) {
                <div class="invalid-feedback" [ngClass]="{ 'd-block': isSubmitted && !isValidFile }"
                  >
                  Invalid file, please check that the file is one of these formats: .jpeg, .jpg, .png, .bmp .
                </div>
              }
            </div>
            <div class="col-md-12 app-buttons-wrap mt-5">
              <div class="submitInput backBack">
                <input [routerLink]="['/sign-up/add-prescription']" id="backBtn" type="button" value="Back">
              </div>
              <div class="submitInput backNext">
                <input (click)="next()" [disabled]="!hasPhotoUploaded" id="nextBtn" type="button" value="Next">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<ng-template #errorsModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Unable to process your photo.</h5>
  </div>
  <div class="modal-body text-center">
    @for (e of errors; track $index) {
      <div class="alert alert-warning">
        {{ e.description }}
      </div>
    }
  </div>
  <div class="modal-footer justify-content-between">
    <button type="button" class="btn gray-btn" (click)="onCloseErrorModal()">Close</button>
  </div>
</ng-template>
